import { Entry } from 'contentful';

export const getImageGridPosition = (index: number, isDesktop: boolean) => {
  if (!isDesktop) {
    return { gridColumn: index === 0 ? 'span 2' : 'span 1' };
  }

  const blockType = Math.floor(index / 5) % 2; // 0 for first type, 1 for second type
  const positionInBlock = index % 5;

  let rowStart, rowEnd, colStart, colEnd, height;

  if (blockType === 0) {
    // First block type: Large image followed by four small images
    if (positionInBlock === 0) {
      // Large image
      rowStart = 1 + Math.floor(index / 10) * 4;
      colStart = 1;
      rowEnd = rowStart + 2;
      colEnd = colStart + 2;
      height = '551px';
    } else {
      // Small images
      rowStart =
        positionInBlock < 3
          ? 1 + Math.floor(index / 10) * 4
          : 2 + Math.floor(index / 10) * 4;
      colStart = positionInBlock === 1 || positionInBlock === 3 ? 3 : 4;
      rowEnd = rowStart + 1;
      colEnd = colStart + 1;
      height = '264px';
    }
  } else {
    // Second block type: Four small images followed by a large image
    if (positionInBlock === 4) {
      // Large image
      rowStart = 3 + Math.floor(index / 10) * 4;
      colStart = 3;
      rowEnd = rowStart + 2;
      colEnd = colStart + 2;
    } else {
      // Small images
      rowStart =
        positionInBlock < 2
          ? 3 + Math.floor(index / 10) * 4
          : 4 + Math.floor(index / 10) * 4;
      colStart = positionInBlock % 2 === 0 ? 1 : 2;
      rowEnd = rowStart + 1;
      colEnd = colStart + 1;
    }
  }

  return {
    gridArea: `${rowStart} / ${colStart} / ${rowEnd} / ${colEnd}`,
    maxHeight: height,
  };
};

export const getTranslationsByIDs = ({
  t,
  ids,
}: {
  t: Entry<Record<string, any>>[];
  ids: string[];
}) => {
  const translationsById: Record<string, any | undefined> = {};

  t.forEach((translation) => {
    if (ids.includes(translation?.fields.id)) {
      translationsById[translation.fields.id] = translation;
    }
  });

  return translationsById;
};

export const getVideoUrls = (mediaObj: any[] | undefined) => {
  const videoDesktop = mediaObj?.[0]?.fields.video.fields.file.url;
  const videoMobile = mediaObj?.[1]?.fields.video.fields.file.url;

  return {
    videoDesktop,
    videoMobile,
  };
};
